export const ROOM_POLLING_INTERVAL_MS = 5000;